import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import realTimePricingDrawerReducer from 'modules/quotes/quoteItemComponents/AdjustRealTimePricingDrawer/data/reducer';

import assemblyTreeSaga from './assemblyTree/data/sagas';
import quoteItemComponentReducer from './data/reducer';
import quoteItemComponentSaga from './data/sagas';
import purchasedComponentsDrawerReducer from './purchasedComponentsDrawer/data/reducer';
import purchasedComponentsDrawerSaga from './purchasedComponentsDrawer/data/sagas';

const reducer = combineReducers({
  purchasedComponentsDrawer: purchasedComponentsDrawerReducer,
  root: quoteItemComponentReducer,
  realTimePricingDrawer: realTimePricingDrawerReducer,
});

const saga = function* () {
  yield all([
    purchasedComponentsDrawerSaga(),
    assemblyTreeSaga(),
    quoteItemComponentSaga(),
  ]);
};

export default { reducer, saga };
